import type {
  ServiceGetAllResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { MemberPoktanResponseData } from './types'

const LIST_MEMBER_POKTAN_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['list_member_poktan', key] as const

const NIK_SEARCH_PATTERN = /^\d{16}$/

const getAll = (
  params: Partial<{
    poktan_id: string
    per_page: number
    page: number
    nik: string
    province_code: string
    city_code: string
    district_code: string
    village_code: string
  }> = {}
): ServiceQueryOptionType<
  ServiceGetAllResponse<MemberPoktanResponseData[]>
> => ({
  queryKey: LIST_MEMBER_POKTAN_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const q = {
        per_page: params.per_page || 10,
        page: params.page || 1,
        nik: NIK_SEARCH_PATTERN.test(params.nik ?? '') ? params.nik : undefined,
        province_code:
          (params.province_code ?? '').length > 0
            ? params.province_code
            : undefined,
        city_code:
          (params.city_code ?? '').length > 0 ? params.city_code : undefined,
        district_code:
          (params.district_code ?? '').length > 0
            ? params.district_code
            : undefined,
        village_code:
          (params.village_code ?? '').length > 0
            ? params.village_code
            : undefined,
        poktan_id:
          (params.poktan_id ?? '').length > 0 ? params.poktan_id : undefined
      }

      const response = await api.get<
        ServiceGetAllResponse<MemberPoktanResponseData[]>
      >('/report/extension-personnel-main/list-poktan-member', { params: q })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const listMemberPoktan = {
  queryKey: LIST_MEMBER_POKTAN_QUERY_KEY,
  getAll
}
